import http from "@/settings/apiSettings"

class CrmShareAppointmentsDataService{
  save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_ShareAppointments", data);
      }
  
}
export default new CrmShareAppointmentsDataService();